import { render, staticRenderFns } from "./EditLeadIbanConnessioneDialog.vue?vue&type=template&id=3bca1160&scoped=true"
import script from "./EditLeadIbanConnessioneDialog.vue?vue&type=script&lang=ts"
export * from "./EditLeadIbanConnessioneDialog.vue?vue&type=script&lang=ts"
import style0 from "./EditLeadIbanConnessioneDialog.vue?vue&type=style&index=0&id=3bca1160&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bca1160",
  null
  
)

export default component.exports